import { ReactComponent as Send } from '@assets/send.svg';
import { ReactComponent as SendError } from '@assets/send-error.svg';
import { styled } from '@stitches/react';

export const SendingStyled = styled('img', {
  width: '$image',
  height: '$image',
});

export const SendStyled = styled(Send, {});

export const SendErrorStyled = styled(SendError);
